package one.healthium.fodmap.di

import org.koin.dsl.module

internal actual fun composeAppPlatformModule() = module {
}